// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import VueRouter from "vue-router";
import "lib-flexible/flexible.js";
import $ from "jquery";
import App from "./App";
import FastClick from "fastclick";
import VueClipboard from "vue-clipboard2";
import "./libs/gt.js";
require("../static/jqueryweui/jquery-weui");
require("../static/jqueryweui/weui.min.css");
require("../static/jqueryweui/jquery-weui.css");
import { Checkbox, Message } from "element-ui";
Vue.use(Checkbox);
Vue.prototype.$message = Message;
if ("addEventListener" in document) {
  document.addEventListener(
    "DOMContentLoaded",
    function () {
      FastClick.attach(document.body);
      FastClick.prototype.focus = function (targetElement) {
        let length;
        if (
          targetElement.setSelectionRange &&
          targetElement.type.indexOf("date") !== 0 &&
          targetElement.type !== "time" &&
          targetElement.type !== "month"
        ) {
          length = targetElement.value.length;
          targetElement.focus();
          targetElement.setSelectionRange(length, length);
        } else {
          targetElement.focus();
        }
      };
    },
    false
  );
}

// import VConsole from 'vconsole/dist/vconsole.min.js'
// let vConsole = new VConsole()
Vue.use(VueRouter);
Vue.use(VueClipboard);
window.jQuery = $;
window.alert = function (name) {
  var iframe = document.createElement("IFRAME");
  iframe.style.display = "none";
  iframe.setAttribute("src", "data:text/plain,");
  document.documentElement.appendChild(iframe);
  window.frames[0].window.alert(name);
  iframe.parentNode.removeChild(iframe);
};
const routes = [
  {
    path: "/",
    component: (resolve) => require(["./components/Login"], resolve),
  },
  {
    path: "/login",
    meta: {
      title: "讯飞语记",
    },
    component: (resolve) => require(["./components/Login"], resolve),
  },
  {
    path: "/member",
    meta: {
      title: "语记会员购买",
    },
    component: (resolve) => require(["./components/Member"], resolve),
  },
  {
    path: "/memberinfo",
    meta: {
      title: "讯飞语记",
    },
    component: (resolve) => require(["./components/MemberInfo"], resolve),
  },
  {
    path: "/noregister",
    meta: {
      title: "",
    },
    component: (resolve) => require(["./components/NoRegister"], resolve),
  },
  {
    path: "/exchange",
    meta: {
      title: "讯飞语记",
    },
    component: (resolve) => require(["./components/Exchange"], resolve),
  },
  {
    path: "/help",
    meta: {
      title: "帮助与反馈",
    },
    component: (resolve) => require(["./components/Help"], resolve),
  },
  {
    path: "/trans",
    meta: {
      title: "转写时长卡购买",
    },
    component: (resolve) => require(["./components/Trans"], resolve),
  },
  {
    path: "/home",
    component: (resolve) => require(["./components/HelloFromVux"], resolve),
  },
  // {
  //   path: "/record",
  //   name: "RecordList",
  //   component: (resolve) =>
  //     require(["./components/record/RecordList"], resolve),
  // },
  // {
  //   path: "/vue-list-demo",
  //   name: "VueListDemo",
  //   component: (resolve) =>
  //     require(["./components/record/VueListDemo"], resolve),
  // },
  {
    path: "/invoice-list",
    name: "InvoiceList",
    meta: {
      title: "购买记录",
    },
    component: (resolve) => require(["./components/invoice/list"], resolve),
  },
  {
    path: "/invoice-form",
    name: "InvoiceForm",
    meta: {
      title: "发票详情",
    },
    component: (resolve) => require(["./components/invoice/form"], resolve),
  },
  {
    path: "/important",
    name: "important",
    meta: {
      title: "语记会员购买",
    },
    component: (resolve) => require(["./components/important/index"], resolve),
  },
  {
    path: "/compare",
    name: "compare",
    meta: {
      title: "权益对比",
    },
    component: (resolve) =>
      require(["./components/important/compare"], resolve),
  },
  {
    path: "/cancellation-account",
    name: "CancellationAccount",
    component: (resolve) =>
      require(["./components/CancellationAccount"], resolve),
  },
  {
    path: "/forget-password",
    name: "ForgetPassword",
    meta: {
      title: "讯飞语记",
    },
    component: (resolve) =>
      require(["./components/password/ForgetPassword.vue"], resolve),
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    meta: {
      title: "重置密码",
    },
    component: (resolve) =>
      require(["./components/password/ResetPassword.vue"], resolve),
  },
  {
    path: "/bill-record",
    name: "BillRecord",
    meta: {
      title: "我的发票",
    },
    component: (resolve) =>
      require(["./components/invoice/BillRecord.vue"], resolve),
  },
];

const router = new VueRouter({
  // mode: 'history',
  routes,
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app-box");



// WEBPACK FOOTER //
// ./src/main.js